<template>
    <f7-page
        :page-content="false"
        name="Onboarding 3"
        navbar-hidden
        no-navbar
        class="onboardingBg"
    >
        <div class="bg-wrapper">
            <div class="parallax-bg" />
            <div class="parallax-bg-2" />
            <div class="blue-tower">

                <f7-block style="max-width: 400px; margin: -60px auto 0; padding: 70px 0 40px;">

                    <h2 style="padding-bottom: 10px">Based on your answers</h2>
                    here are a few topics we will cover

                </f7-block>

                <div class="image">
                    <div style="max-width: 400px; margin: -30px auto 0; padding-top: 10px;">
                        <f7-block style="color: white; min-height: 400px"><br>

                            <f7-block class="arguments">
                                <i class="icon ion-ios-checkmark" /> <br>{{ bullets[selectedBullet].text[0] }}<br style="clear: both">
                                <i class="icon ion-ios-checkmark" /> <br>{{ bullets[selectedBullet].text[1] }}<br style="clear: both">
                                <i class="icon ion-ios-checkmark" /> <br>{{ bullets[selectedBullet].text[2] }}<br style="clear: both">
                                <br><br>And much, much more!
                            </f7-block>
                            <br><br>
                            <br><br>
                        </f7-block>

                    </div>
                </div>
            </div>
            <f7-block class="absBottom">
                <f7-button
                    :color="'red'"
                    :href="'#'"
                    fill
                    round
                    @click="saveTopicsAndGo()"
                >Continue</f7-button>
            </f7-block>
        </div>
    </f7-page>
</template>

<script>
import utils from '../../js/utils';

export default {
    store: ['api', 'user', 'topics', 'topicsIndex', 'myTopics'],
    data () {
        return {
            loaded: false,
            answers: [],
            selectedBullet: 0,
            bullets: [
                {
                    desc: `man','20-40','interested in men','in a relationship`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 25, 13],
                    text: ['When one partner wants it more', 'Drive him wild', 'Giving men pleasure with hands']
                },
                {
                    desc: `man','20-40','interested in men','single-complicated`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 25, 14, 74],
                    text: ['What’s your desire type?', 'Drive him wild', 'Giving men pleasure with hands']
                },
                {
                    desc: `man','20-40','interested in women','in a relationship`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 24, 13],
                    text: ['When one partner wants it more', 'Master dirty talk', 'Make her come for real']
                },
                {
                    desc: `man','20-40','interested in women','single-complicated`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 24, 14, 74],
                    text: ['Make her toes curl', 'Want more pleasure?', 'Shift your self pleasure script']
                },
                {
                    desc: `man','20-40','interested in everyone','in a relationship`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 23, 13],
                    text: ['When one partner wants it more', 'Communication is key', 'Master dirty talk']
                },
                {
                    desc: `man','20-40','interested in everyone','single-complicated`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 23, 14, 74],
                    text: ['What’s your desire type?', 'Want more pleasure?', 'Shift your self pleasure script']
                },
                {
                    desc: `man','50-70','interested in men','in a relationship`,
                    traits: [1, 58, 60, 61, 25, 13],
                    text: ['When one partner wants it more', 'Drive him wild', 'Improve erection performance']
                },
                {
                    desc: `man','50-70','interested in men','single-complicated`,
                    traits: [1, 58, 60, 61, 25, 14, 74],
                    text: ['Drive him wild', 'Giving men pleasure with hands', 'Improve erection performance']
                },
                {
                    desc: `man','50-70','interested in women','in a relationship`,
                    traits: [1, 58, 60, 61, 24, 13],
                    text: ['When one partner wants it more', 'Make her toes curl', 'Improve erection performance']
                },
                {
                    desc: `man','50-70','interested in women','single-complicated`,
                    traits: [1, 58, 60, 61, 24, 14, 74],
                    text: ['Make her toes curl', 'Shift your self pleasure script', 'Improve erection performance']
                },
                {
                    desc: `man','50-70','interested in everyone','in a relationship`,
                    traits: [1, 58, 60, 61, 23, 13],
                    text: ['When one partner wants it more', 'Communication is key', 'Improve erection performance']
                },
                {
                    desc: `man','50-70','interested in everyone','single-complicated`,
                    traits: [1, 58, 60, 61, 23, 14, 74],
                    text: ['Want more pleasure?', 'Shift your self pleasure script', 'Improve erection performance']
                },
                {
                    desc: `woman','20-40','interested in men','in a relationship`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 25, 13],
                    text: ['What’s your desire type?', 'When one partner wants it more', 'Drive him wild']
                },
                {
                    desc: `woman','20-40','interested in men','single-complicated`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 25, 14, 74],
                    text: ['What’s your desire type?', 'Shift your self pleasure script', 'Drive him wild']
                },
                {
                    desc: `woman','20-40','interested in women','in a relationship`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 24, 13],
                    text: ['What’s your desire type?', 'Make her toes curl', 'When one partner wants it more']
                },
                {
                    desc: `woman','20-40','interested in women','single-complicated`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 24, 14, 74],
                    text: ['What’s your desire type?', 'Make her toes curl', 'Shift your self pleasure script']
                },
                {
                    desc: `woman','20-40','interested in everyone','in a relationship`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 23, 13],
                    text: ['What’s your desire type?', 'When one partner wants it more', 'Master dirty talk']
                },
                {
                    desc: `woman','20-40','interested in everyone','single-complicated`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 23, 14, 74],
                    text: ['What’s your desire type?', 'Want more pleasure?', 'Shift your self pleasure script']
                },
                {
                    desc: `woman','50-70','interested in men','in a relationship`,
                    traits: [2, 58, 60, 61, 25, 13],
                    text: ['When one partner wants it more', 'Body and mind out of sync?', 'Want more pleasure? ']
                },
                {
                    desc: `woman','50-70','interested in men','single-complicated`,
                    traits: [2, 58, 60, 61, 25, 14, 74],
                    text: ['Drive him wild', 'Want more pleasure?', 'Body and mind out of sync?']
                },
                {
                    desc: `woman','50-70','interested in women','in a relationship`,
                    traits: [2, 58, 60, 61, 24, 13],
                    text: ['When one partner wants it more', 'Make her toes curl', 'Body and mind out of sync?']
                },
                {
                    desc: `woman','50-70','interested in women','single-complicated`,
                    traits: [2, 58, 60, 61, 24, 14, 74],
                    text: ['Make her toes curl', 'Want more pleasure?', 'Body and mind out of sync?']
                },
                {
                    desc: `woman','50-70','interested in everyone','in a relationship`,
                    traits: [2, 58, 60, 61, 23, 13],
                    text: ['When one partner wants it more', 'Want more pleasure?', 'Body and mind out of sync?']
                },
                {
                    desc: `woman','50-70','interested in everyone','single-complicated`,
                    traits: [2, 58, 60, 61, 23, 14, 74],
                    text: ['Want more pleasure?', 'Body and mind out of sync?', 'Shift your self pleasure script']
                },
                {
                    desc: `other','20-40','interested in men','in a relationship`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Drive him wild']
                },
                {
                    desc: `other','20-40','interested in men','single-complicated`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 25, 14, 74],
                    text: ['Drive him wild', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `other','20-40','interested in women','in a relationship`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 24, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Make her toes curl']
                },
                {
                    desc: `other','20-40','interested in women','single-complicated`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 24, 14, 74],
                    text: ['Make her toes curl', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `other','20-40','interested in everyone','in a relationship`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 23, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Master dirty talk']
                },
                {
                    desc: `other','20-40','interested in everyone','single-complicated`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 23, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Master dirty talk']
                },
                {
                    desc: `other','50-70','interested in men','in a relationship`,
                    traits: [3, 58, 60, 61, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Drive him wild']
                },
                {
                    desc: `other','50-70','interested in men','single-complicated`,
                    traits: [3, 58, 60, 61, 25, 14, 74],
                    text: ['Drive him wild', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `other','50-70','interested in women','in a relationship`,
                    traits: [3, 58, 60, 61, 24, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Make her toes curl']
                },
                {
                    desc: `other','50-70','interested in women','single-complicated`,
                    traits: [3, 58, 60, 61, 24, 14, 74],
                    text: ['Make her toes curl', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `other','50-70','interested in everyone','in a relationship`,
                    traits: [3, 58, 60, 61, 23, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `other','50-70','interested in everyone','single-complicated`,
                    traits: [3, 58, 60, 61, 23, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `trans-masculine','20-40','interested in men','in a relationship`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Drive him wild']
                },
                {
                    desc: `trans-masculine','20-40','interested in men','single-complicated`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 25, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Drive him wild']
                },
                {
                    desc: `trans-masculine','20-40','interested in women','in a relationship`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 24, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Make her toes curl']
                },
                {
                    desc: `trans-masculine','20-40','interested in women','single-complicated`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 24, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Make her toes curl']
                },
                {
                    desc: `trans-masculine','20-40','interested in everyone','in a relationship`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 23, 13],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'When one partner wants it more']
                },
                {
                    desc: `trans-masculine','20-40','interested in everyone','single-complicated`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 23, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Want more pleasure?']
                },
                {
                    desc: `trans-masculine','50-70','interested in men','in a relationship`,
                    traits: [42, 58, 60, 61, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-masculine','50-70','interested in men','single-complicated`,
                    traits: [42, 58, 60, 61, 25, 14, 74],
                    text: ['Drive him wild', 'Exploring trans & genderqueer sexuality', 'Journey over destination'],
                }, {
                    desc: `trans-masculine','50-70','interested in women','in a relationship`,
                    traits: [42, 58, 60, 61, 24, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-masculine','50-70','interested in women','single-complicated`,
                    traits: [42, 58, 60, 61, 24, 14, 74],
                    text: ['Make her toes curl', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-masculine','50-70','interested in everyone','in a relationship`,
                    traits: [42, 58, 60, 61, 23, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-masculine','50-70','interested in everyone','single-complicated`,
                    traits: [42, 58, 60, 61, 23, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','20-40','interested in men','in a relationship`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'What’s your desire type?']
                },
                {
                    desc: `trans-feminine','20-40','interested in men','single-complicated`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 25, 14, 74],
                    text: ['Drive him wild', 'Exploring trans & genderqueer sexuality', 'What’s your desire type?']
                },
                {
                    desc: `trans-feminine','20-40','interested in women','in a relationship`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 24, 13],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'When one partner wants it more']
                },
                {
                    desc: `trans-feminine','20-40','interested in women','single-complicated`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 24, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Make her toes curl']
                },
                {
                    desc: `trans-feminine','20-40','interested in everyone','in a relationship`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 23, 13],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'When one partner wants it more']
                },
                {
                    desc: `trans-feminine','20-40','interested in everyone','single-complicated`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 23, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Want more pleasure?']
                },
                {
                    desc: `trans-feminine','50-70','interested in men','in a relationship`,
                    traits: [43, 58, 60, 61, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','50-70','interested in men','single-complicated`,
                    traits: [43, 58, 60, 61, 25, 14, 74],
                    text: ['Drive him wild', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','50-70','interested in women','in a relationship`,
                    traits: [43, 58, 60, 61, 24, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','50-70','interested in women','single-complicated`,
                    traits: [43, 58, 60, 61, 24, 14, 74],
                    text: ['Make her toes curl', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','50-70','interested in everyone','in a relationship`,
                    traits: [43, 58, 60, 61, 23, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','50-70','interested in everyone','single-complicated`,
                    traits: [43, 58, 60, 61, 23, 14, 74],
                    text: ['Want more pleasure?', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
            ],
        }
    },
    computed: {
        device: function () {
            return f7.device;
        }
    },
    mounted: function () {
        this.selectedBullet = parseFloat(window.localStore.getItem(`selectedBullet`));
    },
    methods: {
        onTopicChange: function (topicId) {
            if (this.myTopics.indexOf(topicId) > -1) {
                if (this.myTopics.length > 1) this.myTopics.splice(this.myTopics.indexOf(topicId), 1);
            } else {
                this.myTopics.push(topicId);
            }
        },
        isEligible: function (topic) {
            return topic.type === 'goal' && utils.checkTraits(this.myTraits, topic);
        },
        saveTopicsAndGo: function () {
            // if (this.myGoals.length < 1) return;
            // this.saveMyGoals();
            let failsafe = true;
            setTimeout(() => {
                if (failsafe) {
                    console.error('onboarding-failsafe!');
                    if (!localStore.getItem('freeFromPartner')) {
                        f7.views['main'].router.navigate('/onboarding4');
                    } else {
                        // auto go to 
                        f7.views['main'].router.navigate('/freeViaPartner');
                    }
                }
            }, 7000);
            this.$events.fire('notifications-push', {
                type: 'goals',
                cb: () => {
                    console.log('notifications-push-cb');
                    this.$events.fire('partners-get', {
                        cb: () => {
                            failsafe = false;
                            console.log('partners-get-cb');
                            if (!window.localStore.getItem('freeFromPartner')) {
                                f7.views['main'].router.navigate('/onboarding4');
                            } else {
                                // auto go to 
                                f7.views['main'].router.navigate('/freeViaPartner');
                            }
                        }
                    });
                }
            });
        },
        saveMyTopics: function () {
            this.$http.post(`${this.api}/users/${this.user.id}/topics`, {
                topicIds: this.myTopics
            }).then(
                () => {
                    console.log('topics saved');
                },
                response => {
                    console.error(response.body.message || 'Unknown error');
                }
            );
        }
    }
};
</script>

<style lang="less" scoped>
.theme-dark {
    h2 {
        color: white;
    }
}
.bg-wrapper {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
}
.parallax-bg {
    position: absolute;
    left: calc(~'-1200px' - 50vw);
    top: 0;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_top.png) top right no-repeat;
    background-size: 3670.5px 171.5px;
    height: 171.5px;
    width: 3670.5px;
}
.parallax-bg-2 {
    position: absolute;
    left: calc(~'-3800px' - 50vw);
    bottom: 0px;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_bottom.png) bottom left
        no-repeat;
    background-size: 5954.5px 804px;
    height: 804px;
    width: 5954.5px;
}
.absBottom {
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(20px);
    overflow: visible;
    // border-top: 1px solid #efefef;
    text-align: center;
    position: fixed;
    z-index: 100000;
    padding-bottom: 50px;
    width: 100%;
    margin: 0;
    bottom: 0px;
}

.goal {
    img {
        height: 120px;
        position: absolute;
        top: -15px;
        left: -20px;
        opacity: 0.7;
    }
    cursor: pointer;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
    border-radius: 14px;
    width: 100%;
    height: 90px;
    background: rgba(255, 255, 255, 0.5);
    transition: all 0.3 ease;
    backdrop-filter: blur(20px);
    //border: 2px solid transparent;
    h3 {
        text-align: left;
        margin-left: 120px;
        font-family: AndesBook;
        font-style: normal;
        font-size: 20px;
        line-height: 56px;
        color: #000000;
        letter-spacing: -1px;
    }
    &.selected {
        background: rgba(255, 255, 255, 1);
        //border: 2px solid #749592;
        img {
            opacity: 1;
        }
    }
}
.blue-tower {
    overflow-y: scroll;
    height: 100%;
    padding-top: 180px;
    max-width: 100%;
    z-index: 20000;
    .image {
        overflow: hidden;
        background: url(../../img/1.2.0/onboarding_blue_bg.png) top center no-repeat;
        background-size: 744px 1923px;
        width: 100%;
        max-width: 744px;
        margin-left: calc(~'50vw' - 372px);
    }
}
@media screen and (max-width: 1000px) {
    .blue-tower {
        .image {
            margin-left: 0;
        }
    }
}

.arguments {
    max-width: 400px;
    margin: 0 auto;
    text-align: left;
    line-height: 17px;
    font-size: 16px;
    color: white;
    .icon {
        font-size: 45px;
        // color: #1f6500;
        color: white;
        padding-right: 10px;
        float: left;
    }
}
@media only screen and (max-width: 360px) {
    .arguments {
        font-size: 15px;
    }
}
</style>
